import type { EditorPlugin } from '../../../types/aha-editor';
import ItalicMarkPlugin from './ItalicMarkPlugin';
import Markdown from '../../Markdown/Markdown';

const ItalicMarkdownPlugin: EditorPlugin = {
  name: 'Italic Markdown plugin',
  dependencies: [Markdown, ItalicMarkPlugin],
  markdown: [
    {
      type: 'mark',
      shortcuts: ['_', '\\*'],
      mark: 'italic',
    },
  ],
};

export default ItalicMarkdownPlugin;
